import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex h-full" }
const _hoisted_2 = { class: "fixed inset-0 z-40 flex" }
const _hoisted_3 = { class: "absolute top-0 right-0 -mr-12 pt-2" }
const _hoisted_4 = { class: "h-0 flex-1 overflow-y-auto pt-5 pb-4 bg-gray-100" }
const _hoisted_5 = { class: "hidden lg:flex lg:flex-shrink-0" }
const _hoisted_6 = {
  key: 0,
  class: "flex w-72 flex-col"
}
const _hoisted_7 = { class: "flex min-h-0 flex-1 flex-col border-r border-gray-200 bg-gray-100" }
const _hoisted_8 = { class: "flex flex-1 flex-col overflow-y-auto pt-5 pb-4" }
const _hoisted_9 = {
  class: "flex-1",
  "aria-label": "Sidebar"
}
const _hoisted_10 = { class: "flex min-w-0 flex-1 flex-col overflow-hidden" }
const _hoisted_11 = {
  key: 0,
  class: "lg:hidden"
}
const _hoisted_12 = {
  key: 1,
  "data-secondary-top": "",
  class: "hidden lg:flex items-center border-b border-gray-200 bg-gray-50 px-4 py-1.5"
}
const _hoisted_13 = { class: "relative z-0 flex flex-1 overflow-hidden" }
const _hoisted_14 = { class: "relative z-0 flex-1 overflow-y-auto focus:outline-none xl:order-last" }

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { Bars3CenterLeftIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { ref } from 'vue'

import BasicSpinner from '@/components/BasicSpinner'
import { providePageLoading } from '@/composables/usePageLoading'


export default {
  __name: 'SecondaryNav',
  props: { fullWidth: { type: Boolean, default: false } },
  setup(__props) {

const sidebarOpen = ref(false)


const pageLoading = providePageLoading()

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.sidebar)
      ? (_openBlock(), _createBlock(_unref(TransitionRoot), {
          key: 0,
          as: "template",
          show: sidebarOpen.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Dialog), {
              as: "div",
              class: "relative z-40 lg:hidden",
              onClose: _cache[2] || (_cache[2] = $event => (sidebarOpen.value = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "transition-opacity ease-linear duration-300",
                  "enter-from": "opacity-0",
                  "enter-to": "opacity-100",
                  leave: "transition-opacity ease-linear duration-300",
                  "leave-from": "opacity-100",
                  "leave-to": "opacity-0"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("div", { class: "fixed inset-0 bg-gray-600 bg-opacity-75" }, null, -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "transition ease-in-out duration-300 transform",
                    "enter-from": "-translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transition ease-in-out duration-300 transform",
                    "leave-from": "translate-x-0",
                    "leave-to": "-translate-x-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "relative flex w-full max-w-xs flex-1 flex-col bg-white focus:outline-none" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TransitionChild), {
                            as: "template",
                            enter: "ease-in-out duration-300",
                            "enter-from": "opacity-0",
                            "enter-to": "opacity-100",
                            leave: "ease-in-out duration-300",
                            "leave-from": "opacity-100",
                            "leave-to": "opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                                  onClick: _cache[0] || (_cache[0] = $event => (sidebarOpen.value = false))
                                }, [
                                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)),
                                  _createVNode(_unref(XMarkIcon), {
                                    class: "h-6 w-6 text-white",
                                    "aria-hidden": "true"
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("nav", {
                              "aria-label": "Sidebar",
                              onClick: _cache[1] || (_cache[1] = $event => (sidebarOpen.value = false))
                            }, [
                              _renderSlot(_ctx.$slots, "sidebar")
                            ])
                          ])
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  }),
                  _cache[6] || (_cache[6] = _createElementVNode("div", {
                    class: "w-14 flex-shrink-0",
                    "aria-hidden": "true"
                  }, null, -1))
                ])
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["show"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.$slots.sidebar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("nav", _hoisted_9, [
                  _renderSlot(_ctx.$slots, "sidebar")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.$slots.top || _ctx.$slots.sidebar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", {
              "data-secondary-top": "",
              class: _normalizeClass(["flex items-start border-b border-gray-200 bg-gray-50 pr-2 py-1.5 h-full", !_ctx.$slots.sidebar && 'pl-4'])
            }, [
              (_ctx.$slots.sidebar)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "flex h-full w-12 items-center justify-center rounded-md text-gray-500 hover:text-gray-900 shrink-0",
                    onClick: _cache[3] || (_cache[3] = $event => (sidebarOpen.value = true))
                  }, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)),
                    _createVNode(_unref(Bars3CenterLeftIcon), {
                      class: "h-6 w-6",
                      "aria-hidden": "true"
                    })
                  ]))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "top")
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.top)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _renderSlot(_ctx.$slots, "top")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("main", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(["h-full w-full", !__props.fullWidth && 'mx-auto max-w-6xl'])
          }, [
            _renderSlot(_ctx.$slots, "main")
          ], 2)
        ]),
        _createElementVNode("div", {
          "data-page-loading": "",
          class: _normalizeClass(["absolute inset-0 z-20 flex items-center justify-center backdrop-blur-sm transition-opacity duration-100", _unref(pageLoading) ? 'opacity-100 cursor-wait' : 'opacity-0 pointer-events-none'])
        }, [
          _createVNode(_unref(BasicSpinner), { size: "medium" })
        ], 2)
      ])
    ])
  ]))
}
}

}